<template>
    <td-dialog :title="title" :before-close="permissionDialogClose" :visible.sync="dialogPermissionVisible" width="550px" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form :model="formPermissionInfo" ref="formPermissionInfo" :rules="rules">
            <el-row>
                <el-form-item :label="$t('common.RESTYPENAME')" :label-width="formLabelWidth" prop="resName">
                    <td-input v-model="formPermissionInfo.resName" :maxlength="20"></td-input>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item :label="$t('common.AUTH_STR')" :label-width="formLabelWidth" prop="sPermissionStr">
                    <td-input v-model="formPermissionInfo.sPermissionStr" :maxlength="50"></td-input>
                </el-form-item>
                <el-form-item :label-width="formLabelWidth">
                    <span>{{ $t('common.PERMISSION_STR_TIP') }}</span>
                </el-form-item>
            </el-row>
            <!-- <el-row>
                <el-form-item :label="$t('common.RES_TYPE_STR')" :label-width="formLabelWidth" prop="resTypeId">
                    <td-input v-model="formPermissionInfo.resTypeId"></td-input>
                </el-form-item>
            </el-row> -->
            <el-row>
                <el-form-item :label="$t('common.DESCRIPTION')" :label-width="formLabelWidth" prop="description">
                    <td-input type="textarea" v-model="formPermissionInfo.description" :maxlength="100"></td-input>
                </el-form-item>
            </el-row>
            <el-row v-show="showParent">
                <el-form-item :label="$t('common.CHOOSEPARENT')" :label-width="formLabelWidth">
                    <!-- <el-col :span="8" :sm="12" :lg="11" :xl="14">
                        <el-form-item prop="resParentName">
                            <td-input v-model="formPermissionInfo.resParentName" :readonly="true" placeholder=""></td-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item>
                            <td-button type="button" @click="showTree()">{{ $t('common.PLEASE_SELECT') }}</td-button>
                        </el-form-item>
                    </el-col> -->
                    <td-tree-select
                        ref="tree"
                        v-model="formPermissionInfo.resParentName"
                        :treeList="menuRoles"
                        :lazyloading="false"
                        :defaultProps="defaultProps"
                        :isSingleCheck="true"
                        :inputShow="true"
                        nodeKey="id"
                        :multiple="false"
                    ></td-tree-select>
                </el-form-item>
            </el-row>
            <!-- <el-row>
                <el-col>
                    <el-form-item :label-width="formLabelWidth">
                        <el-tree
                            v-show="treeShow"
                            :data="menuRoles"
                            :props="defaultProps"
                            node-key="id"
                            :check-strictly="true"
                            :highlight-current="true"
                            default-expand-all
                            :expand-on-click-node="false"
                            ref="tree"
                            @check-change="checkChange"
                            @node-click="nodeClick"
                        >
                        </el-tree>
                    </el-form-item>
                </el-col>
            </el-row> -->
            <!-- <div>
                    <td-input v-model="formPermissionInfo.resParentName" prop="resName"></td-input>
                    <td-button type="button" @click="showTree()">{{$t('common.PLEASE_SELECT')}}</td-button>
                </div> -->

            <td-transfer v-model="checkedPermission" :data="resType" :filterable="false" ref="trans" :titles="titles"></td-transfer>
        </el-form>
        <span slot="footer">
            <td-button type="primary" @click="submitForm('formPermissionInfo')" :loading="loading">{{ $t('common.SAVE') }}</td-button>
            <td-button type="button" @click.native="permissionDialogClose">{{ $t('common.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import resourceApi from '../assets/api.js';
export default {
    props: ['title', 'dialogPermissionVisible', 'editItem', 'isAddData', 'sSysFlg'],
    created() {
        let param = {
            sSysFlg: this.sSysFlg
        };
        resourceApi.getAllResType(param, response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('res/getAllResType', response.data.statusMessage);
                return;
            }
            let resPid = '';
            let resParentName = [];
            if (!this.isAddData) {
                resPid = this.editItem.sParentId;
            }
            let data = response.data.content;
            const res = [];
            for (let i = 0; i < data.length; i++) {
                res.push({
                    key: data[i].sId,
                    label: data[i].sName
                });
                if (resPid === data[i].sId) {
                    resParentName.push({ sId: resPid, sName: data[i].sName });
                }
            }
            this.formPermissionInfo.resParentName = resParentName;
            // this.$refs.tree.dataDisplay(resParentName);

            let result = this.transData(data, 'sId', 'sParentId', 'children');
            this.menuRoles = result;
        });
        let param1 = {
            sysFlg: this.sSysFlg
        };
        resourceApi.getAllAuthType(param1, response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('role/getAllAuthType', response.data.statusMessage);
                return;
            }
            let auths = response.data.content;
            const resVal = [];
            for (let i = 1; i <= auths.length; i++) {
                resVal.push({
                    key: auths[i - 1].sId,
                    label: auths[i - 1].sName
                });
            }
            this.resType = resVal;
        });
        // if (!this.isAddData) {
        //     resourceApi.getAllAuthTypeByResId({resId: this.formPermissionInfo.resId}, response => {
        //         if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
        //             this.$message.error(response.data.statusMessage)
        //             this.$log.error('role/getAllAuthTypeByResId', response.data.statusMessage)
        //             return
        //         }
        //         let auths = response.data.content
        //         const data = []
        //         for (let i = 1; i <= auths.length; i++) {
        //             data.push(auths[i - 1].sId)
        //         }
        //         this.checkedPermission = data
        //         // console.log(this.checkedPermission)
        //     })
        // }
        // 为编辑状态则进行初始化数据
        if (!this.isAddData) {
            this.initEditData();
        } else {
            // Permission类型默认选中第一个
            this.formPermissionInfo.iType = String(this.options[0].value);
        }
    },
    // 定义变量
    data() {
        let validateResName = (rule, value, callback) => {
            let sId = '';
            if (!this.isAddData) {
                sId = this.formPermissionInfo.resId;
            }
            let param = {
                resName: value,
                sSysFlg: this.sSysFlg,
                resId: sId
            };

            resourceApi.getResInfoByName(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('res/getResInfoByName', response.data.statusMessage);
                    return;
                }
                if (response.data.count > 0) {
                    callback(this.$t('error.ERROR_RES_CAPTION_REPEAT'));
                } else {
                    callback();
                }
            });
        };
        let validateAuthStr = (rule, value, callback) => {
            let sId = '';
            if (!this.isAddData) {
                sId = this.formPermissionInfo.resId;
            }
            let param = {
                sPermissionStr: value,
                sSysFlg: this.sSysFlg,
                resId: sId
            };

            resourceApi.getResInfoByName(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('res/getResInfoByName', response.data.statusMessage);
                    return;
                }
                if (response.data.count > 0) {
                    callback(this.$t('error.ERROR_PERMISSION_STR_REPEAT'));
                } else {
                    callback();
                }
            });
        };
        // let validateResTypeId = (rule, value, callback) => {
        //     let sId = ''
        //     if (!this.isAddData) {
        //         sId = this.formPermissionInfo.resId
        //     }
        //     let param = {
        //         resTypeId: value,
        //         resId: sId
        //     }

        //     resourceApi.getResInfoByName(JSON.stringify(param), response => {
        //         if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
        //             this.$message.error(response.data.statusMessage)
        //             this.$log.error('res/getResInfoByName', response.data.statusMessage)
        //             return
        //         }
        //         if (response.data.count > 0) {
        //             callback(this.$t('error.ERROR_RES_TYPE_REPEAT'))
        //         } else {
        //             callback()
        //         }
        //     })
        // }
        return {
            // Permission表单信息
            formPermissionInfo: {
                resId: '',
                description: '',
                resParentName: [],
                sParentId: '',
                resName: '',
                authId: '',
                sPermissionStr: '',
                resTypeId: ''
            },
            loading: false,
            titles: [this.$t('common.SURPLUS_AUTH'), this.$t('common.CHECKED_AUTH')],
            editCheckId: '',
            resType: [],
            menuRoles: [],
            treeShow: false,
            showParent: true,
            defaultProps: {
                children: 'children',
                label: 'sName'
            },
            checkedPermission: [],
            // Permission类型数组
            options: [
                {
                    value: '0',
                    label: this.$t('common.RABBITMQ')
                }
            ],
            formLabelWidth: '30%',
            // 对表单进行数据验证
            rules: {
                resName: [
                    { required: true, message: this.$t('error.ERROR_RES_NULL'), trigger: 'blur' },
                    {
                        pattern: this.$regex.USERCAPTION_RULE,
                        message: this.$t('error.ERROR_RES_CAPTION_ILLEGAL')
                    },
                    { validator: validateResName, trigger: 'blur' }
                ],
                sPermissionStr: [
                    { required: true, message: this.$t('error.ERROR_AUTH_STR_NULL'), trigger: 'blur' },
                    { min: 1, max: 50, message: this.$t('error.ERROR_CAPTION_MAX_LENGTH'), trigger: 'blur' },
                    { pattern: this.$regex.AUTH_STR, message: this.$t('error.ERROR_AUTH_STR_ILLEGAL') },

                    { validator: validateAuthStr, trigger: 'blur' }
                ],
                description: [{ min: 1, max: 100, message: this.$t('error.ERROR_URL_MAX_LENGTH'), trigger: 'blur' }]
            }
        };
    },

    // 定义并实现方法体
    methods: {
        // 初始化编辑数据
        initEditData() {
            this.formPermissionInfo.resId = this.editItem.resId;
            this.formPermissionInfo.resName = this.editItem.resName;
            this.formPermissionInfo.description = this.editItem.description;
            this.formPermissionInfo.resTypeId = this.editItem.resTypeId;
            this.formPermissionInfo.sPermissionStr = this.editItem.sPermissionStr;
            // console.log(this.editItem);
            // debugger;
            // this.checkedPermission = this.editItem.authName.split('、')
            let authIds = this.editItem.authId.split(',');
            if (authIds.length > 0) {
                //转成int后台key为int，key为str直接传string
                // this.checkedPermission = authIds.map(value => {
                //     return parseInt(value);
                // });
                this.checkedPermission = authIds;
            }
            // 根节点不允许修改父节点
            // if (this.editItem.sParentId === 0 || this.editItem.sParentId === '0') {
            //     this.showParent = false;
            // }
        },
        transData(a, idStr, pidStr, chindrenStr) {
            let r = [];
            let hash = {};
            let id = idStr;
            let pid = pidStr;
            let children = chindrenStr;
            let i = 0;
            let j = 0;
            let len = a.length;
            for (; i < len; i++) {
                hash[a[i][id]] = a[i];
            }
            for (; j < len; j++) {
                let aVal = a[j];
                let hashVP = hash[aVal[pid]];
                if (hashVP) {
                    !hashVP[children] && (hashVP[children] = []);
                    hashVP[children].push(aVal);
                } else {
                    r.push(aVal);
                }
            }

            return r;
        },
        checkChange(item, node, self) {
            if (node === true) {
                // 点击未选中复选框
                this.editCheckId = item.sId;
                this.$refs.tree.setCheckedKeys([item.sId]);
            } else {
                if (this.editCheckId === item.sId) {
                    // 点击已选中复选框，保证至少一个选中
                    this.$refs.tree.setCheckedKeys([item.sId]);
                }
            }
        },
        nodeClick(item, node, self) {
            this.editCheckId = item.sId;
            this.treeShow = false;
            this.formPermissionInfo.sParentId = item.sId;
            this.formPermissionInfo.resParentName = item.sName;
            this.$refs.tree.setCheckedKeys([item.sId]);
        },
        showTree() {
            this.treeShow = true;
        },
        // 提交数据
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.loading = true;
                    let selectRootNode = this.$refs.tree.getSelectedNodes();
                    if (selectRootNode.sId === this.formPermissionInfo.resId) {
                        this.$message({ showClose: true, message: this.$t('common.PARENT_RES'), type: 'error' });
                        return;
                    }
                    let parentId = 0;
                    if (selectRootNode.sId) {
                        parentId = selectRootNode.sId;
                    }
                    let content = {
                        sSysFlg: this.sSysFlg,
                        resName: this.formPermissionInfo.resName,
                        sParentId: parentId,
                        description: this.formPermissionInfo.description,
                        resId: this.formPermissionInfo.resId,
                        authId: this.$refs.trans.getAllRightKeys(),
                        sPermissionStr: this.formPermissionInfo.sPermissionStr,
                        resTypeId: this.formPermissionInfo.resTypeId
                    };
                    // console.log(this.formPermissionInfo);
                    // debugger;
                    // return;
                    let successMsg = this.$t('common.ADD_SUCCESS');
                    if (!this.isAddData) {
                        // content.resId = this.editItem.sId
                        successMsg = this.$t('common.MODIFY_SUCCESS');
                    }
                    resourceApi.insertPermissionInfo(JSON.stringify(content), response => {
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('res/insertPermissionInfo', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: successMsg, type: 'success' });
                        this.permissionDialogClose();
                        this.$emit('submit');
                    });
                }
            });
        },
        // 关闭窗口之前需要调用的方法
        permissionDialogClose() {
            this.$emit('permissionDialogClose');
            this.$refs['formPermissionInfo'].resetFields(); // 重置表单数据
        }
    }
};
</script>
